import { render, staticRenderFns } from "./midseason-sale.vue?vue&type=template&id=55ce4864"
import script from "./midseason-sale.vue?vue&type=script&lang=js"
export * from "./midseason-sale.vue?vue&type=script&lang=js"
import style0 from "./midseason-sale.vue?vue&type=style&index=0&id=55ce4864&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports